import {
  GET_MT_AGENCIES_LIST,
  GET_MT_BANNERS_LIST,
  GET_MT_CAMPAIGNS_LIST,
  GET_TIKTOK_ADVERTISERS_LIST,
  GET_VK_BANNER_LIST,
  GET_VK_CAMPAIGNS_LIST,
  GET_VK_CLIENT_LIST,
  HIDE_MT_AGENCIES_LIST_LOADER,
  HIDE_MT_BANNERS_LIST_LOADER, HIDE_MT_CAMPAIGNS_LIST_LOADER,
  HIDE_TIKTOK_ADVERTISERS_LIST_LOADER,
  HIDE_VK_BANNERS_LIST_LOADER,
  HIDE_VK_CAMPAIGNS_LIST_LOADER,
  HIDE_VK_CLIENT_LOADER, INTEGRATION_STATE_INIT,
  SET_MT_AGENCIES_LIST,
  SET_MT_BANNERS_LIST,
  SET_MT_CAMPAIGNS_LIST,
  SET_TIKTOK_ADVERTISERS_LIST,
  SET_VK_BANNER_LIST,
  SET_VK_CAMPAIGNS_LIST,
  SET_VK_CLIENT_LIST,
  SHOW_MT_AGENCIES_LIST_LOADER,
  SHOW_MT_BANNERS_LIST_LOADER,
  SHOW_MT_CAMPAIGNS_LIST_LOADER,
  SHOW_TIKTOK_ADVERTISERS_LIST_LOADER,
  SHOW_VK_BANNERS_LIST_LOADER,
  SHOW_VK_CAMPAIGNS_LIST_LOADER,
  SHOW_VK_CLIENT_LOADER
} from "./actionTypes";

export const integrationStateInit = () => ({
  type: INTEGRATION_STATE_INIT,
})

export const getCampaignsVkList = data => ({
  type: GET_VK_CAMPAIGNS_LIST,
  payload: data
})

export const setCampaignsVkList = payload => ({
  type: SET_VK_CAMPAIGNS_LIST,
  payload
})

export const showCampaignsVkListLoader = () => ({
  type: SHOW_VK_CAMPAIGNS_LIST_LOADER
})

export const hideCampaignsVkListLoader = () => ({
  type: HIDE_VK_CAMPAIGNS_LIST_LOADER
})

export const getClientsVkList = data => ({
  type: GET_VK_CLIENT_LIST,
  payload: data
});

export const setClientsVkList = payload => ({
  type: SET_VK_CLIENT_LIST,
  payload
});

export const showClientsVkListLoader = () => ({
  type: SHOW_VK_CLIENT_LOADER
});

export const hideClientsVkListLoader = () => ({
  type: HIDE_VK_CLIENT_LOADER
});

export const getBannersVkList = data => ({
  type: GET_VK_BANNER_LIST,
  payload: data
});

export const setBannersVkList = payload => ({
  type: SET_VK_BANNER_LIST,
  payload
});

export const showBannersVkListLoader = () => ({
  type: SHOW_VK_BANNERS_LIST_LOADER
});

export const hideBannersVkListLoader = () => ({
  type: HIDE_VK_BANNERS_LIST_LOADER
});

export const getTikTokAdvertisersList = data => ({
  type: GET_TIKTOK_ADVERTISERS_LIST,
  payload: data
});

export const setTikTokAdvertisersList = payload => ({
  type: SET_TIKTOK_ADVERTISERS_LIST,
  payload
});

export const showTikTokAdvertisersListLoader = () => ({
  type: SHOW_TIKTOK_ADVERTISERS_LIST_LOADER
});

export const hideTikTokAdvertisersListLoader = () => ({
  type: HIDE_TIKTOK_ADVERTISERS_LIST_LOADER
});

export const getMTAgenciesList = data => ({
  type: GET_MT_AGENCIES_LIST,
  payload: data
});

export const setMTAgenciesList = payload => ({
  type: SET_MT_AGENCIES_LIST,
  payload
});

export const getMTBannersList = data => ({
  type: GET_MT_BANNERS_LIST,
  payload: data
});

export const setMTBannersList = payload => ({
  type: SET_MT_BANNERS_LIST,
  payload
});

export const getMTCampaignsList = data => ({
  type: GET_MT_CAMPAIGNS_LIST,
  payload: data
});

export const setMTCampaignsList = payload => ({
  type: SET_MT_CAMPAIGNS_LIST,
  payload
});

export const showMTAgenciesListLoader = () => ({
  type: SHOW_MT_AGENCIES_LIST_LOADER
});

export const hideMTAgenciesListLoader = () => ({
  type: HIDE_MT_AGENCIES_LIST_LOADER
});

export const showMTBannersListLoader = () => ({
  type: SHOW_MT_BANNERS_LIST_LOADER
});

export const hideMTBannersListLoader = () => ({
  type: HIDE_MT_BANNERS_LIST_LOADER
});

export const showMTCampaignsListLoader = () => ({
  type: SHOW_MT_CAMPAIGNS_LIST_LOADER
});

export const hideMTCampaignsListLoader = () => ({
  type: HIDE_MT_CAMPAIGNS_LIST_LOADER
});
